var AccessDeniedController = function($scope, $stateParams) {
    var self = this;

    self.initialise = function() {
        
    };

    self.initialise();
};

angular
    .module('dashboard')
    .controller('AccessDeniedController', ['$scope',
        '$stateParams',
        AccessDeniedController]);